import {Divider} from '@/components/ui/divider/Divider'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {useTranslation} from '@/translations/i18n'
import {MedicalReportUploadDocumentField} from '../upload-document-section-fields/MedicalReportUploadDocumentField'

/**
 * Attachment of a single note report: rendered for the report types belonging to the "evaluations"
 * group, where the report can be filled with a note, an attachment, or both.
 */
export const MedicalReportAttachmentSection = () => {
    const {t} = useTranslation()

    return (
        <>
            <Divider direction="horizontal" />
            <FormSection
                title={t('commons:attachment')}
                description={t('medical_records:evaluation_attachment_description')}
            >
                <MedicalReportUploadDocumentField />
            </FormSection>
        </>
    )
}
